import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '.';
const getPortal = state => state.portal;
const getIsDevPortal = createSelector([getPortal], ({
  portalType
}) => portalType === 'DEV');
const useIsDevPortal = () => {
  const isDevPortal = useAppSelector(getIsDevPortal);
  return isDevPortal;
};
export default useIsDevPortal;